import React from 'react'
import styled from '@emotion/styled'

const Svg = styled('svg')`
    fill: #000;
`
const MsWordIcon = () => (
    <Svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <path
            d="M12.6891 33.9258H32.8818C33.0733 33.9258 33.23 33.7691 33.23 33.5776V13.0368H27.3114C26.7356 13.0368 26.267 12.5681 26.267 11.9923V6.07374H12.6891C12.4976 6.07374 12.3409 6.23041 12.3409 6.42189V33.5776C12.3409 33.7691 12.4976 33.9258 12.6891 33.9258Z"
            fill="white"
        />
        <path
            d="M32.7377 12.3405L26.9633 6.56603V11.9923C26.9633 12.1838 27.1199 12.3405 27.3114 12.3405H32.7377Z"
            fill="white"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33.6199 12.2388L27.0649 5.68312C26.8687 5.48809 26.6035 5.37826 26.3268 5.37744H12.6891C12.1132 5.37744 11.6446 5.84605 11.6446 6.42189V33.5776C11.6446 34.1535 12.1132 34.6221 12.6891 34.6221H32.8818C33.4577 34.6221 33.9263 34.1535 33.9263 33.5776V12.9769C33.9263 12.6984 33.8176 12.4358 33.6199 12.2388ZM26.9633 6.56603L32.7377 12.3405H27.3114C27.2191 12.3403 27.1307 12.3035 27.0654 12.2383C27.0002 12.173 26.9634 12.0846 26.9633 11.9923V6.56603ZM12.6891 33.9258H32.8818C33.0733 33.9258 33.23 33.7691 33.23 33.5776V13.0368H27.3114C26.7356 13.0368 26.267 12.5681 26.267 11.9923V6.07374H12.6891C12.4976 6.07374 12.3409 6.23041 12.3409 6.42189V33.5776C12.3409 33.67 12.3776 33.7585 12.4429 33.8238C12.5082 33.8891 12.5967 33.9258 12.6891 33.9258Z"
            fill="#605E5C"
        />
        <path
            d="M30.7929 24.1776H22.7854V24.8739H30.7929C30.8852 24.8739 30.9738 24.8372 31.0391 24.7719C31.1044 24.7066 31.1411 24.6181 31.1411 24.5257C31.1411 24.4334 31.1044 24.3448 31.0391 24.2795C30.9738 24.2143 30.8852 24.1776 30.7929 24.1776Z"
            fill="#103F91"
        />
        <path
            d="M30.7929 22.0887H22.7854V22.785H30.7929C30.8852 22.785 30.9738 22.7483 31.0391 22.683C31.1044 22.6177 31.1411 22.5292 31.1411 22.4368C31.1411 22.3445 31.1044 22.2559 31.0391 22.1906C30.9738 22.1254 30.8852 22.0887 30.7929 22.0887Z"
            fill="#185ABD"
        />
        <path
            d="M30.7929 19.9998H22.7854V20.6961H30.7929C30.8852 20.6961 30.9738 20.6594 31.0391 20.5941C31.1044 20.5288 31.1411 20.4403 31.1411 20.3479C31.1411 20.2556 31.1044 20.167 31.0391 20.1017C30.9738 20.0364 30.8852 19.9998 30.7929 19.9998Z"
            fill="#2B7CD3"
        />
        <path
            d="M30.7929 17.9109H22.7854V18.6072H30.7929C30.8852 18.6072 30.9738 18.5705 31.0391 18.5052C31.1044 18.4399 31.1411 18.3514 31.1411 18.259C31.1411 18.1667 31.1044 18.0781 31.0391 18.0128C30.9738 17.9475 30.8852 17.9109 30.7929 17.9109Z"
            fill="#41A5EE"
        />
        <path
            d="M7.46682 29.0517H20.0002C20.3696 29.0517 20.7238 28.905 20.985 28.6438C21.2461 28.3826 21.3928 28.0284 21.3928 27.6591V15.1257C21.3928 14.7563 21.2461 14.4021 20.985 14.1409C20.7238 13.8798 20.3696 13.7331 20.0002 13.7331H7.46682C7.09748 13.7331 6.74327 13.8798 6.4821 14.1409C6.22094 14.4021 6.07422 14.7563 6.07422 15.1257V27.6591C6.07422 28.0284 6.22094 28.3826 6.4821 28.6438C6.74327 28.905 7.09748 29.0517 7.46682 29.0517Z"
            fill="#185ABD"
        />
        <path
            d="M11.5256 23.7055C11.5485 23.8879 11.5639 24.0467 11.5708 24.1818H11.5973C11.6286 23.8712 11.6787 23.562 11.7463 23.2571L12.9822 17.9109H14.5802L15.8586 23.1777C15.9227 23.4374 15.9756 23.7682 16.0188 24.1706H16.0397C16.0578 23.8928 16.1023 23.5725 16.1727 23.2097L17.1962 17.9109H18.6501L16.8606 25.5702H15.1609L13.941 20.4962C13.9055 20.35 13.8651 20.1592 13.8213 19.9239C13.7876 19.7541 13.76 19.5831 13.7384 19.4114H13.7175C13.7036 19.5367 13.6757 19.7219 13.6347 19.967C13.5936 20.2135 13.5609 20.3939 13.5365 20.5122L12.3911 25.5702H10.6649L8.85942 17.9109H10.3405L11.4531 23.2682C11.4782 23.3789 11.5019 23.5251 11.5256 23.7055Z"
            fill="#F9F7F7"
        />
    </Svg>
)
export default MsWordIcon
